import axios from 'axios'
import baseUrl from './baseUrl'
const http = {}
//申報後台
var BackEndServiceInstance = axios.create({
    // timeout: 60000,
    baseURL: baseUrl.PdpsBackEndService,
    validateStatus(status) {
        switch (status) {
          case 400:
            alert('400 請求錯誤');
            break
          case 403:
            alert('403 拒絕訪問');
            break
          case 404:
            alert('404 請求錯誤,未找到該資源');
            break
          case 500:
            alert('500 服務端錯誤');
            break
          case 503:
            console.log('503 服務無法使用');
            location.href = "/PdpsCli/Static/Error.html";
            break
        // case 401:
        //     Message.warning({
        //         message: '授權失敗，请重新登入'
        //     })
        //     store.commit('LOGIN_OUT')
        //     setTimeout(() => {
        //         window.location.reload()
        //     }, 1000)
        //     return
        }
        return status >= 200 && status < 300
    }
})
BackEndServiceInstance.interceptors.response.use(
  response => {
      return response.data
  },
  err => {
    if (err && err.response) {
      console.log(err.response);
    } else {
      let hrefArray = location.href.split('/');
        if(!hrefArray.filter(x => x.toUpperCase() === "LOGIN").length){
          sessionStorage.removeItem("LoginInfo");
          alert('連接逾時，請重新登入!');
          if(hrefArray.filter(x => x.toUpperCase() == "CY").length ){
            location.href = "/PdpsCli/BackStage/CY/Login";
          } else {
            location.href = "/PdpsCli/BackStage/PDIS/Login";
          }
        }
    }
    document.getElementById('ajaxLoading').style.display = 'none';
    // console.log(err.message);
    return Promise.reject(err.response)
  }
)
//管理平台
var BackstageApiInstance = axios.create({
  //timeout: 60000,
  baseURL: baseUrl.PdpsBackstageApi,
  validateStatus(status) {
      switch (status) {
        case 400:
          alert('400 請求錯誤');
          break
        case 403:
          alert('403 拒絕訪問');
          break
        case 404:
          alert('404 請求錯誤,未找到該資源');
          break
        case 500:
          alert('500 服務端錯誤');
          break
        case 503:
          console.log('503 服務無法使用');
          location.href = "/PdpsCli/Static/Error.html";
          break
      // case 401:
      //     Message.warning({
      //         message: '授權失敗，请重新登入'
      //     })
      //     store.commit('LOGIN_OUT')
      //     setTimeout(() => {
      //         window.location.reload()
      //     }, 1000)
      //     return
      }
      return status >= 200 && status < 300
  }
})
BackstageApiInstance.interceptors.response.use(
  response => {
      return response.data
  },
  err => {
      if (err && err.response) {
        console.log(err.response);
      } else {
        let hrefArray = location.href.split('/');
        if(!hrefArray.filter(x => x.toUpperCase() === "LOGIN").length){
          sessionStorage.removeItem("LoginInfo");
          alert('連接逾時，請重新登入!');
          if(hrefArray.filter(x => x.toUpperCase() == "CY").length ){
            location.href = "/PdpsCli/BackStage/CY/Login";
          } else {
            location.href = "/PdpsCli/BackStage/PDIS/Login";
          }
        }
      }
      document.getElementById('ajaxLoading').style.display = 'none';
      // console.log(err.message);
      return Promise.reject(err.response)
  }
)
//申報
var Instance = axios.create({
  //timeout: 60000,
  baseURL: baseUrl.Basic,
  validateStatus(status) {
      switch (status) {
        case 400:
          alert('400 請求錯誤');
          break
        case 403:
          alert('403 拒絕訪問');
          break
        case 404:
          alert('404 請求錯誤,未找到該資源');
          break
        case 500:
          alert('500 服務端錯誤');
          break
        case 503:
          console.log('503 服務無法使用');
          location.href = "/PdpsCli/Static/Error.html";
          break
      // case 401:
      //     Message.warning({
      //         message: '授權失敗，请重新登入'
      //     })
      //     store.commit('LOGIN_OUT')
      //     setTimeout(() => {
      //         window.location.reload()
      //     }, 1000)
      //     return
      }
      return status >= 200 && status < 300
  }
})
Instance.interceptors.response.use(
  response => {
      return response.data
  },
  err => {
    if (err && err.response) {
      console.log(err.response);
    } else {
      let hrefArray = location.href.split('/');
        if(!hrefArray.filter(x => x.toUpperCase() === "LOGIN").length){
          sessionStorage.removeItem("LoginInfo");
          alert('連接逾時，請重新登入!');
          if(hrefArray.filter(x => x.toUpperCase() == "CY").length){
            location.href = "/PdpsCli/BackStage/CY/Login";
          } else {
            location.href = "/PdpsCli/BackStage/PDIS/Login";
          }
        }
    }
    document.getElementById('ajaxLoading').style.display = 'none';
    // console.log(err.message);
    return Promise.reject(err.response)
  }
)


// 添加请求拦截器
// instance.interceptors.request.use(
//     function(config) {
//         // 请求头添加token
//         if (store.state.UserToken) {
//             config.headers.Authorization = `Bearer ${store.state.UserToken}`
//         }
//         return config
//     },
//     function(error) {
//         return Promise.reject(error)
//     }
// )


http.get = function(url,type,data,options) {
  let axiosInstance;
   switch(type){
     case 'BackEndService':
      axiosInstance = BackEndServiceInstance;
       break;
     case 'BackstageApi':
      axiosInstance = BackstageApiInstance;
       break;
     default:
      axiosInstance = Instance;
       break;
   }
    let loading
    if (!options || options.isShowLoading !== false) {
        loading = document.getElementById('ajaxLoading')
        loading.style.display = 'block'
    }
    return new Promise((resolve, reject) => {
      axiosInstance
        .get(url, { params: data }, options)
        .then(response => {
            if (!options || options.isShowLoading !== false) {
                loading = document.getElementById('ajaxLoading')
                loading.style.display = 'none'
            }
            if (response) {
                resolve(response)
            } else {
                reject(response.messages)
            }
        })
        .catch(e => {
            console.log(e)
        })
    })
}

http.post = function(url,type, data, options) {
  let axiosInstance;
   switch(type){
     case 'BackEndService':
      axiosInstance = BackEndServiceInstance;
       break;
     case 'BackstageApi':
      axiosInstance = BackstageApiInstance;
       break;
     default:
      axiosInstance = Instance;
       break;
   }
    let loading
    if (!options || options.isShowLoading !== false) {
        loading = document.getElementById('ajaxLoading')
        loading.style.display = 'block'
    }
    return new Promise((resolve, reject) => {
      axiosInstance
            .post(url, data, options)
            .then(response => {
                if (!options || options.isShowLoading !== false) {
                    loading = document.getElementById('ajaxLoading')
                    loading.style.display = 'none'
                }
                resolve(response);
                // TODO 列印申報表要多加 result
                // if (response.result) {
                //     resolve(response)
                // } else {
                //     reject(response.messages)
                // }
            })
            .catch(e => {
                console.log(e)
            })
    })
}

export default http
